import type { SyslogEventFragmentFragment } from '@api/gql/graphql';
import { DrawerDetail } from '@common/ui/DrawerDetail/DrawerDetail';
import { Paper, Typography } from '@mui/material';
import { formatText } from '@SystemLog/utils/formatText';
import { DateTime } from '@utils';

interface SystemLogDetailsProps {
  event: SyslogEventFragmentFragment & {
    previousTargetObject?: string | null;
    currentTargetObject?: string | null;
  };
}

export default function SystemLogDetails({ event }: SystemLogDetailsProps) {
  const showActorId = event.actor.name.toLowerCase() !== event.actor.id.toLowerCase();

  return (
    <Paper elevation={0}>
      <DrawerDetail label="Time" value={DateTime.fromDate(new Date(event.timestamp)).readableWithSeconds} />
      <DrawerDetail label="Action" value={formatText(event.action)} />
      <DrawerDetail
        label="Actor"
        value={
          <Typography variant="body2">
            {formatText(event.actor.name)}
            {showActorId && (
              <Typography component="span" variant="caption" color="text.secondary">
                {' '}
                ({event.actor.id})
              </Typography>
            )}
          </Typography>
        }
      />
      <DrawerDetail
        label="Target"
        value={
          <Typography variant="body2">
            {event.target.name}
            <Typography component="span" variant="caption" color="text.secondary">
              {' '}
              ({formatText(event.target.type)})
            </Typography>
          </Typography>
        }
      />
      <DrawerDetail label="Source" value={formatText(event.source)} noDivider />
    </Paper>
  );
}
